// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"203":"confetti","231":"checkout","383":"manage","405":"gov","708":"artist","798":"gaa"}[chunkId] || chunkId) + "-legacy." + {"203":"fa5fd3a3","231":"6964f5d7","378":"1f37a564","383":"ec18236d","405":"153a875b","579":"5f0d347a","708":"7748de77","798":"7214d8fe"}[chunkId] + ".js";
};